import { Wrench } from 'lucide-react';

export default function MaintenancePage({ message }) {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="maintenance-page">
      <div className="max-w-lg w-full text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#C41E3A]/10 border-2 border-[#C41E3A] mb-8">
          <Wrench size={36} className="text-[#C41E3A]" />
        </div>
        <h1 className="font-['Oswald'] text-4xl sm:text-5xl uppercase tracking-wide text-white mb-4">
          Down for <span className="text-[#C41E3A]">Maintenance</span>
        </h1>
        <div className="h-1 w-24 bg-gradient-to-r from-[#C41E3A] to-[#D4AF37] mx-auto mb-6" />
        <p className="text-gray-300 text-base leading-relaxed mb-8" data-testid="maintenance-message">
          {message || "We're temporarily down for maintenance. We'll be back shortly — thanks for your patience!"}
        </p>
        <p className="text-[#D4AF37] text-sm uppercase tracking-widest font-bold">
          Canadian Wellness &amp; Fitness
        </p>
      </div>
    </div>
  );
}
